import React from 'react';
import "../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>List of Holidays</h1>
                <p>Home &gt; List of Holidays</p>
            </div>
        </div>
    )
}

export default Hero;